<template>
  <div v-if="totalRows" class="d-flex justify-content-end mt-4 align-items-center menu-container" ref="menuContainer">
    <div class="d-flex page-range-container align-items-center me-4">
      <div v-if="!$isMobile()" class="page-range">
        Showing {{ page_range_start }} - {{ page_range_end }} of {{ totalRows }}
      </div>
      <!-- <div @click="downloadCSVData" class="p-2 hard-link" >Export CSV</div> -->
      <b-pagination
        class="b-pagination"
        :value="activePage"
        @input="setPage"
        :total-rows="totalRows"
        :per-page="page_size"
        first-text="<<"
        prev-text="<"
        next-text=">"
        last-text=">>"
      >
      </b-pagination>
    </div>
</div>
</template>

<script>
import { PAGE_SIZE } from "@/constants";
import StorageService from "@/storage/storage.service";

export default {
  emits: ["set-page"],
  props: {
    totalRows: {
      type: Number,
      required: true,
    },
    activePage: {
      type: Number,
      required: true,
    },
    tableName: {
      type: String,
      required: false,
    },
    pageSize: {
      type: Number,
      required: false,
    },
    pageSizeLocalStorageName: {
      type: String,
      required: false,
    },
    invoiceType: {
      type: String,
    },
  },
  data() {
    return {
      open_menu: false,
      PAGE_SIZE,
      page_size: this.pageSize, // default page size
      page_range_start: 0,
      page_range_end: 0,
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    let pageSizes = JSON.parse(
      StorageService.getFromLocalStorage("pageSize")
    );

    if (this.pageSize) {
      this.page_size = this.pageSize;
    }
    else if (pageSizes && this.pageSizeLocalStorageName && pageSizes[this.pageSizeLocalStorageName]) {
      this.page_size = pageSizes[this.pageSizeLocalStorageName];
    } 
    else {
      this.page_size = PAGE_SIZE;
    }
    this.calculatePageRange();
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  watch:{
    totalRows(val){
      this.calculatePageRange();
    },
    activePage(val){
      this.calculatePageRange();
    }
  },
  methods: {
    openMenu() {
      this.open_menu = !this.open_menu;
    },
    calculatePageRange(){
    this.page_range_start = (this.activePage - 1) * this.page_size + 1;
    this.page_range_end =
      this.activePage * this.page_size < this.totalRows
        ? this.activePage * this.page_size
        : this.totalRows;
    },
    handleClickOutside(event) {
      const menuElement = this.$refs.menuContainer;
      if (menuElement && !menuElement.contains(event.target)) {
        this.open_menu = false;
      }
    },
    setPage(pageNo) {
      if (pageNo !== null) {
        this.$emit("set-page", pageNo, this.page_size);
      }
    },
    changePageSize(pageSize) {
      this.page_size = pageSize;
      if (this.pageSizeLocalStorageName) {
        let pageSizes = JSON.parse(
          StorageService.getFromLocalStorage("pageSize")
        );
        if (!pageSizes) {
          pageSizes = {};
        }
        pageSizes[this.pageSizeLocalStorageName] = pageSize;
        StorageService.setIntoLocalStorage(
          "pageSize",
          JSON.stringify(pageSizes)
        );
      }

    this.calculatePageRange();
      this.open_menu = false;
    this.$emit("set-page", 1, pageSize);
    },
  },
};
</script>

<style lang="scss">
@import "./BasePagination.scss";
</style>
